const ITEMS = [
    "Suporte Técnico Presencial",
    "Sites Profissionais",
    "Sistema de Cardápio Digital",
    "Campo Limpo & Zona Sul SP",
    "Configuração de Redes Wi-Fi",
    "Zero Taxas de Delivery",
    "Atendimento Rápido via WhatsApp",
];

const Row = () => (
    <div className="flex w-max shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 text-sm font-bold uppercase tracking-[0.28em] text-slate-500">
                    {item}
                </span>
                <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" className="shrink-0">
                    <rect x="2" y="2" width="6" height="6" rx="1" transform="rotate(45 5 5)" fill="#00D2FF" opacity="0.5" />
                </svg>
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative overflow-hidden border-y border-white/[0.06] bg-[#0D121F]/60 py-5"
        aria-hidden="true"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#07090E] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#07090E] to-transparent" />
    </div>
);
